import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { useEntityFinderContext } from "../context/EntityFinderContext";
import { Contact } from "@/bryntum-lib/models/Contact";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";

export const ContactTab = () => {
  const { data, handleClose } = useEntityFinderContext();
  const { editorHandler } = useSwivuBryntumContext();
  const contacts = data as Contact[];

  const handleContactClick = (contact: Contact) => {
    editorHandler.openEditor(
      EDITOR_KEYS.contactEditor,
      { id: contact.id },
      { contact },
      { by: "recordId", useExisting: true }
    );
    handleClose();
  };

  return (
    <div className="flex flex-col h-full overflow-auto bg-background">
      {contacts.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-muted-foreground p-8 text-center">
          <svg className="w-12 h-12 mb-4 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <p className="text-sm">No contacts found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {contacts.map((contact, index) => (
            <div
              key={contact.id}
              onClick={() => handleContactClick(contact)}
              className={`px-4 py-3 bg-card hover:opacity-90 cursor-pointer transition-all border-b border-border/40 last:border-b-0 rounded-md ${index === 0 ? "border-t-0" : ""}`}
            >
              <div className="font-medium text-foreground line-clamp-1">{contact.name || "N/A"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
